import * as queries from './queries';
import app from '../../app';

export async function startSDM({ dispatch, commit, getters, rootGetters }, parameters) {
  const selectedPatientId = rootGetters['patientList/selectedPatient'].patientId;
  const version = parameters && parameters.version ? parameters.version : rootGetters['patientSummary/currentVersion'];

  // if an SDM session has already been started then do nothing
  if (getters.isSDMStarted) return;

  // if no patient has been selected, throw an error and stop
  if (!selectedPatientId) {
    const error = new Error('No patient has been selected');
    dispatch('error/submit', error, { root: true });
    return;
  }

  try {
    const { data, errors } = await app.apolloClient.query({
      query: queries.createUpdateSDMEncounter,
      variables: {
        version: version,
        status: 'inprogress',
        patientId: parseInt(selectedPatientId),
      },
    });

    if (data && !errors) {
      await dispatch('patientSummary/update', null, { root: true });
      // await dispatch('alerts/getRecent', selectedPatientId, { root: true });

      commit('start', {
        patientId: selectedPatientId,
        type: 'SDM',
      });
    } else if (errors.length) {
      errors.forEach((error) => {
        dispatch('error/submit', error, { root: true });
      });
    }
  } catch (error) {
    dispatch('error/submit', error, { root: true });
  }
}

export async function startRegular({ dispatch, commit, getters, rootGetters }) {
  const selectedPatientId = rootGetters['patientList/selectedPatient'].patientId;

  if (getters.isFollowUpStarted) return;

  if (!selectedPatientId) {
    const error = new Error('No patient has been selected');
    dispatch('error/submit', error, { root: true });
    return;
  }

  try {
    // if a patient has been selected but no patient data is available
    // then get the patient data first
    if (selectedPatientId && !rootGetters['patientSummary/id']) {
      await dispatch('patientSummary/get', null, { root: true });
    }

    commit('start', {
      patientId: selectedPatientId,
    });
  } catch (error) {
    dispatch('error/submit', error, { root: true });
  }
}

export async function end({ dispatch, commit, getters, rootGetters }) {
  if (!getters.isFollowUpStarted && !getters.isSDMStarted) return;

  if (getters.type === 'SDM') {
    try {
      const { data, errors } = await app.apolloClient.query({
        query: queries.createUpdateSDMEncounter,
        variables: {
          version: parseInt(rootGetters['patientSummary/currentVersion']),
          status: 'done',
          patientId: parseInt(rootGetters['patientSummary/id']),
        },
      });

      if (data && !errors) {
        await dispatch('patientSummary/update', getters.patientId, { root: true });
        commit('close');
        return true;
      } else if (errors.length) {
        errors.forEach((error) => {
          dispatch('error/submit', error, { root: true });
        });
        return false;
      }
    } catch (error) {
      dispatch('error/submit', error, { root: true });
      return false;
    }
  }

  commit('close');
  return true;
}

export async function restore({ dispatch, commit, rootGetters }, patientId) {
  if (!patientId) return;

  const storedPatientId = localStorage.getItem('followupSessionPatientId');
  if (!storedPatientId || storedPatientId !== patientId) return;

  if (rootGetters['patientSummary/id'] !== patientId) {
    await dispatch('patientSummary/get', patientId, { root: true });
  }

  commit('restore');
}

export async function updateSDM({ dispatch, commit }, { patientId, version, status = 'skipped' }) {
  try {
    const { data, errors } = await app.apolloClient.query({
      query: queries.createUpdateSDMEncounter,
      variables: {
        patientId : parseInt(patientId),
        version : parseInt(version),
        status: status,
      },
    });

    if (data && !errors) {
      await dispatch('patientSummary/update', patientId, { root: true });
      return true;
    } else if (errors.length) {
      errors.forEach((error) => {
        dispatch('error/submit', error, { root: true });
        return false;
      });
    }

    return false;
  } catch (error) {
    dispatch('error/submit', error, { root: true });
    return false;
  }
}

export async function reset({ commit }) {
  commit('reset');
}
